import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { SharedModule } from 'src/app/shared/shared.module';
import { SandboxCardModule } from '../../my-sandbox/sandbox-card/sandbox-card.module';
import { ServiceCardModule } from '../service-card/service-card.module';
import { CardComponent } from './card.component';



@NgModule({
  declarations: [
    CardComponent
  ],
  imports: [
    CommonModule,
    SharedModule,

    SandboxCardModule,
    ServiceCardModule,
  ],
  exports: [
    CardComponent
  ],
})
export class CardModule { }
